import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";

export const postArticleProfile = ({commit, dispatch}, payload) => {
    
    axios.post('/articles/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        console.log(JSON.stringify(res.data))

        if(res.data.status) {
            dispatch('findArticles')
        } else {
            commit('setAlertBox', {title: 'Error', message: 'Error'})    
        }

    })
    .catch(error => {
        
        console.log(error)
commit('setAlertBox', {title: 'Error', message: 'Error please try again!!'})                
    })

}

export const findArticles = ({commit}) => {

    axios.get('/articles/index.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('setArticleList', res.data.response)    
        }

    })
    .catch(error => {
        
        console.log(error)
commit('setAlertBox', {title: 'Error', message: 'Error please try again!!'})                
    })

}


// WEBPACK FOOTER //
// ./src/store/modules/articles/actions.js